/**
 * The separator between the values of a multi-valued attribute when they are
 * shown as one text: DICOM's own value delimiter, the backslash (PS3.5
 * §6.4), set off by spaces so that `1.4.0 \ hn_ct 1.2.0` reads as two values
 * and never as one run-together string.
 */
export const MULTI_VALUE_SEPARATOR = ' \\ ';

/**
 * The values of a string attribute as one text, in their order, separated by
 * {@link MULTI_VALUE_SEPARATOR}.
 *
 * Takes each shape a parsed dataset hands back for a string attribute: an
 * array of values, a single string — whose raw backslashes are value
 * delimiters, since no string value may hold one — or nothing, which is the
 * empty text. An empty value keeps its place, so the values stay countable.
 */
export function multiValuedStringText(value: unknown): string {
    const values = Array.isArray(value)
        ? value
        : typeof value === 'string'
          ? value.split('\\')
          : [];
    return values
        .map((item) =>
            item === null || item === undefined ? '' : String(item)
        )
        .join(MULTI_VALUE_SEPARATOR);
}
